module.exports = __webpack_public_path__ + "img/analytics-marketing-team-4.5d79ac0b.svg";